<template>
  <div class="templatePayTypeSubscript">
    <div :class="getBadgeClassName(4, 'enterpriseS')" v-if="showWho == 'enterpriseS'">
     <span class="words">  </span>
    </div>
    <div class="commonVip" v-if="showWho == 'commonVip'">
     <span class="words"> VIP </span>
    </div>
    <div :class="getBadgeClassName(6, 'companyVip')" v-else-if="showWho == 'companyVip'" >
      <span class="words">企业VIP</span>
    </div>
    <div class="bought" v-else-if="showWho == 'bought'" >
      <span class="words">已购买</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  name: "templatePayTypeSubscript",
  mixins: [vipBadge],
  components: {},
  props: {
    item: {
      payType: 0,
      price: 0,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["UserLevelType", 'IsOldUser']),
    showWho: function () {
      let type = this.item.payType;
      console.log(`Turbo ~ type:`, type)
      let tt = this.item.tt;
      if (type === 0) {
        return "free";
      } else if (type === 1 || type === 2 || type === 3) {
        if (tt) {
          return "bought";
        } else {
          if (this.IsOldUser) {
            return "commonVip";
          }
          return 'enterpriseS';
        }
      } else if (type === 4) {
        if (this.IsOldUser) {
          return "commonVip";
        }
        return 'enterpriseS';
      } else if (type === 6) {
        return "companyVip";
      } else {
        return "free";
      }
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.templatePayTypeSubscript {
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.free {
  display: none;
}
.words {
  color: #fff;
  font-size: 12px;
  transform: scale(0.83);
  position: relative;
  display: block;
  top: -1px;
}
.price,
.discount {
  background: linear-gradient(108deg, #fa2efc 0%, #325eff 99%);
  border-radius: 4px;
  font-size: 12px;
  color: #fff;
  padding: 0 6px;
}
.bought {
  width: 50px;
  height: 16px;
  background: linear-gradient(352deg, #01ACCB 0%, #5DE3C2 100%);
  border-radius: 8px;
}
.commonVip {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 16px;
  background: linear-gradient(122deg, #FABE63 0%, #E74500 100%);
  border-radius: 8px;
}
.companyVip {
  width: 50px;
  height: 16px;
  background: linear-gradient(352deg, #2F58FE 0%, #49A6FC 100%);
  border-radius: 8px;
}
.enterpriseS {
  width: 50px;
  height: 16px;
  // content: url(../../assets/enterpriseS.png);
  content: url(../../assets//enterpriseSVIP.svg);
}
.pro {
  width: 30px;
  height: 18px;
  content: url(../../assets/pro.png);
}
.proPlus {
  width: 32px;
  height: 18px;
  content: url(../../assets/proPlus.png);
}
</style>



// WEBPACK FOOTER //
// src/components/common/templatePayTypeSubscript.vue